module.exports = __webpack_public_path__ + "img/cbr-action-menu-inverted.57a2f0e4.svg";